import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Fire, PuzzlePiece } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DIFFICULTY, starText } from "@/lib/daily";

// Lobby card for today's daily puzzle (pages/Daily.jsx), with your streak.
export default function DailyCard({ className = "" }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/daily").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const t = data.days[0] || {};
  const status = t.won
    ? "Solved"
    : t.finished
    ? "Not solved today. Try the archive."
    : t.tries
    ? `${3 - t.tries} ${3 - t.tries === 1 ? "try" : "tries"} left`
    : `${DIFFICULTY[t.difficulty]} · win in one turn · par ${t.par} tiles`;
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center gap-4 p-5 md:px-8 rounded-2xl border border-border bg-surface ${className}`}
      data-testid="daily-card"
    >
      <div className="flex items-center gap-4 min-w-0">
        <div className="w-12 h-12 rounded-xl bg-brand/15 text-brand flex items-center justify-center flex-none">
          <PuzzlePiece size={26} weight="duotone" />
        </div>
        <div className="min-w-0">
          <div className="font-display text-xl font-bold tracking-tight">
            Daily Puzzle #{t.n}
            <span className="ml-2 text-amber-400 tracking-wider text-base" title={`${DIFFICULTY[t.difficulty]} puzzle`}>
              {starText(t.difficulty)}
            </span>
          </div>
          <div className="text-sm text-muted-foreground">
            {status}
            {data.streak > 0 && (
              <span className="ml-2 inline-flex items-center gap-0.5 text-orange-400 font-semibold">
                <Fire size={14} weight="fill" /> {data.streak}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="sm:ml-auto flex gap-2">
        <Button asChild variant="ghost" className="rounded-full" data-testid="daily-card-archive">
          <Link to="/daily/archive">Archive</Link>
        </Button>
        <Button asChild className="rounded-full bg-brand hover:bg-brand-hover text-brand-foreground" data-testid="daily-card-play">
          <Link to="/daily">
            {t.finished ? "See result" : "Play"} <ArrowRight size={15} weight="bold" className="ml-1" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
